import React from "react";
import { getURLHelper } from "../../helpers/url";

const SecondColumn = ({
    menuStyleData,
    sideMenu,
    footerContent,
    footerTextColor,
    spaceClass,
    order,
    boxWidth
}) => {
    let menuAnchorStyle = {
        fontFamily: menuStyleData && menuStyleData.menuFont,
        color: menuStyleData && menuStyleData.menuFontcolor,
        fontSize: menuStyleData && (menuStyleData.menuFontsize + "px"),
    }

    return (
        <div className={`antera-footer-content-container ${menuStyleData.menuTextAlignment ?? 'text-left'}`} style={{order:(order ? order : 2), width:boxWidth, flex:`0 0 ${boxWidth}`}}>
            <div className={`footer-widget ${!!footerTextColor ? footerTextColor :""} 
            ${spaceClass?.pt} ${spaceClass?.pb} ${spaceClass?.pl} ${spaceClass?.pr} ${spaceClass?.mb} ${spaceClass?.mt} ${spaceClass?.mr} ${spaceClass?.ml}`} >
                <div className="footer-title">
                    <h3
                        className="antera-footer-column-title"
                        style={{
                            fontFamily: menuStyleData.menuFont,
                            color: menuStyleData?.titleFontColor || menuStyleData?.menuFontcolor,
                            fontSize: menuStyleData?.titleFontSize && (menuStyleData.titleFontSize + "px"),
                        }}> {(footerContent && footerContent.secondColumnTitle != "undefined" && footerContent.secondColumnTitle != undefined && footerContent.secondColumnTitle != "") ? footerContent.secondColumnTitle : ""}</h3>
                </div>
                <div className="footer-list">
                    <ul className="antera-footer-list-container">
                        {footerContent && footerContent.secondColumnData && footerContent.secondColumnData.length > 0 &&
                            footerContent.secondColumnData.map((data, key) => {
                                return (
                                    <li key={key} className="antera-footer-list-item-container">
                                        {
                                            getURLHelper(data.link) ?
                                                <a href={getURLHelper(data.link)}
                                                    onMouseOver={(e) => e.target.style.color = menuStyleData.menuHovercolor}
                                                    onMouseOut={(e) => e.target.style.color = menuStyleData.menuFontcolor}
                                                    style={menuAnchorStyle}
                                                    className="antera-footer-list-item-link"
                                                    target={getURLHelper(data.link).startsWith('http') ? '_blank' : ''} >{data.label}</a>
                                                : <span
                                                    className="antera-footer-list-item-link-text"
                                                    style={menuAnchorStyle}>{data.label}</span>
                                        }
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
            </div>
        </div>
    );
};


export default SecondColumn;
